import React, { useEffect, useState, useRef } from 'react';
import { IoIosAdd } from "react-icons/io";

const Counter = () => {
    const countersRef = useRef(null);
    const [activated, setActivated] = useState(false);
    const duration = 3000; // Animation duration in milliseconds

    useEffect(() => {
        const handleScroll = () => {
            if (!countersRef.current) return;

            const container = countersRef.current;
            const containerTop = container.offsetTop;
            const containerHeight = container.offsetHeight;
            const scrollTop = window.pageYOffset;

            if (scrollTop > containerTop - containerHeight - 200 && !activated) {
                setActivated(true);
            } else if ((scrollTop < containerTop - containerHeight - 500 || scrollTop === 0) && activated) {
                setActivated(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [activated]);

    useEffect(() => {
        if (activated && countersRef.current) {
            const counters = countersRef.current.querySelectorAll(".counter span[data-count]");
            counters.forEach(counter => {
                const target = parseInt(counter.dataset.count);
                const stepTime = 20; // Time interval between updates
                const steps = duration / stepTime;
                const increment = target / steps;

                let count = 0;
                counter.innerText = 0;

                const counterInterval = setInterval(() => {
                    count += increment;
                    if (count < target) {
                        counter.innerText = Math.ceil(count);
                    } else {
                        counter.innerText = target; // Ensure exact target
                        clearInterval(counterInterval);
                    }
                }, stepTime);
            });
        }
    }, [activated]);

    return (
        <div className='container-wrapper-el'>
        <div className="container-wrapper">
            <div ref={countersRef} className="counter-container">
                <div className="counter-box">
                    <div className="counter">
                        <h1>
                            <span data-count="1340" data-type="clients">0</span>
                            <IoIosAdd className='add-icon'/>
                        </h1>
                        <h3>Client Totals</h3>
                    </div>
           
                    <div className="counter">
                        <h1>
                            <span data-count="25" data-type="programs">0</span>
                            <IoIosAdd className='add-icon'/>
                        </h1>
                        <h3>Our Programs</h3>
                    </div>
                    <div className="counter">
                        <h1>
                            <span data-count="20" data-type="experience">0</span>
                            <IoIosAdd className='add-icon'/>
                        </h1>
                        <h3>Years of Experience</h3>
                    </div>
                    <div className="counter">
                        <h1>
                            <span data-count="500" data-type="projects">0</span>
                            <IoIosAdd className='add-icon'/>
                        </h1>
                        <h3>Successful Projects</h3>
                    </div>
                </div>
            </div>
        </div>
        </div>

    );
};

export default Counter;
